// Lightweight safe markup renderer for revision guides.
// Supported: # Title, ## Subtitle, ### Small heading, **bold**, [red]..[/red],
// [green]..[/green], [brown]..[/brown], - bullet, 1. numbered list

const COLOR_CLASSES = {
  red: "text-destructive",
  green: "text-success",
  brown: "text-primary",
};

function renderInline(text, keyPrefix) {
  const parts = [];
  const regex = /(\*\*(.+?)\*\*)|(\[(red|green|brown)\](.+?)\[\/\4\])/g;
  let last = 0;
  let m;
  let i = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[2] !== undefined) {
      parts.push(<strong key={`${keyPrefix}-${i}`} className="font-bold">{m[2]}</strong>);
    } else {
      parts.push(<span key={`${keyPrefix}-${i}`} className={COLOR_CLASSES[m[4]]}>{m[5]}</span>);
    }
    last = regex.lastIndex;
    i += 1;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

export function GuideContent({ body }) {
  const lines = (body || "").split("\n");
  const blocks = [];
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (line.startsWith("- ")) {
      const items = [];
      while (i < lines.length && lines[i].startsWith("- ")) {
        items.push(lines[i].slice(2));
        i += 1;
      }
      blocks.push({ type: "ul", items });
      continue;
    }
    if (/^\d+\.\s/.test(line)) {
      const items = [];
      while (i < lines.length && /^\d+\.\s/.test(lines[i])) {
        items.push(lines[i].replace(/^\d+\.\s/, ""));
        i += 1;
      }
      blocks.push({ type: "ol", items });
      continue;
    }
    blocks.push({ type: "line", line });
    i += 1;
  }
  return (
    <div data-testid="guide-content">
      {blocks.map((b, bi) => {
        if (b.type === "ul") {
          return (
            <ul key={bi} className="ml-5 list-disc space-y-1 my-2">
              {b.items.map((t, j) => (
                <li key={j} className="text-sm md:text-base leading-relaxed">{renderInline(t, `${bi}-${j}`)}</li>
              ))}
            </ul>
          );
        }
        if (b.type === "ol") {
          return (
            <ol key={bi} className="ml-5 list-decimal space-y-1 my-2">
              {b.items.map((t, j) => (
                <li key={j} className="text-sm md:text-base leading-relaxed">{renderInline(t, `${bi}-${j}`)}</li>
              ))}
            </ol>
          );
        }
        const line = b.line;
        if (line.startsWith("### ")) {
          return <h4 key={bi} className="font-display text-base font-bold mt-6 mb-2">{renderInline(line.slice(4), bi)}</h4>;
        }
        if (line.startsWith("## ")) {
          return <h3 key={bi} className="font-display text-lg font-bold mt-7 mb-2">{renderInline(line.slice(3), bi)}</h3>;
        }
        if (line.startsWith("# ")) {
          return <h2 key={bi} className="font-display text-xl md:text-2xl font-bold tracking-tight mt-8 mb-3">{renderInline(line.slice(2), bi)}</h2>;
        }
        if (line.trim() === "") {
          return <div key={bi} className="h-2" />;
        }
        return <p key={bi} className="text-sm md:text-base leading-relaxed my-2">{renderInline(line, bi)}</p>;
      })}
    </div>
  );
}
